module.exports = __webpack_public_path__ + "media/images/partners/malaysia-8d722a90357c8bccab71df1fbb2697dc.png";